import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import Button from '@mui/material/Button'
import apiClient from '../../apiClient';
import {
    Box,
    Typography,
} from '@mui/material';
import { NetworkRunQueueTable } from './NetworkRunQueueTable';
import { getStore } from '../../Store'
import { SelectRowFromTable } from '../universal/Axios';
import { Switch } from '@mui/material';

const store = getStore();

const EditNetworkBatch = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [networkBatchObject, setNetworkBatchObject] = useState({})
    const [networkBatchObjectUpdateTrigger, setNetworkBatchObjectUpdateTrigger] = useState(false)
    //const [networkBatchObject, setNetworkBatchObject] = useState({})

    useEffect(() => {
        if (id != null) {
            SelectRowFromTable("select * from network_batch where id = '" + id + "';", setNetworkBatchObject)
        }
    }, [id, networkBatchObjectUpdateTrigger])
    const handleAutoRunToggle = () => {
        store.updateStatusMessage("Toggling Auto Run")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Toggle_Network_Batch_Auto_Run",
                "network_batch_id": id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully toggled Auto Run!")
            setNetworkBatchObjectUpdateTrigger(!networkBatchObjectUpdateTrigger)
        })
    }

    const resetAnalytics = () => {
        store.updateStatusMessage("Clearing existing analytics data and resetting network run statuses...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Reset_Batch_Analytics",
                "network_batch_id": id
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully synced network batches!")
            window.location.reload();
        }).catch(function (error) {
            store.updateErrorMessage("Error: " + error)
        })
    }
    const ResetAnalyticsButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            onClick={() => resetAnalytics()}
        >
            Reset Analytics
        </Button>
    
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box sx={{ marginBottom: '10px' }}>
                    <Typography variant="h6">Results for {id}</Typography>
                    <Switch checked={networkBatchObject.is_auto_run} onChange={handleAutoRunToggle} /> Auto Run
                </Box>
                <Box>
                    <ResetAnalyticsButton />
                </Box>
            </Box>
            <Box sx={{ m: 2 }}>
                <NetworkRunQueueTable network_batch_id={id} />
            </Box>
        </Box>
    )
}

export default EditNetworkBatch